// lurik-frontend/src/infra/two-factor-api/useTwoFactorApi.ts
import { useAxiosInstances } from '../axios-instance/useAxiosInstances';
import {
  IActivateTwoFactorRequest,
  IActivateTwoFactorResponse,
  IVerifyTwoFactorRequest,
  IVerifyTwoFactorResponse,
  ICompleteTwoFactorLoginRequest,
  ICompleteTwoFactorLoginResponse,
  IDeactivateTwoFactorRequest,
  IDeactivateTwoFactorResponse,
  IGenerateBackupCodesRequest,
  IGenerateBackupCodesResponse,
  IConfigureCompanyTwoFactorRequest,
  IConfigureCompanyTwoFactorResponse
} from '../../application/models/ITwoFactor';

export const useTwoFactorApi = () => {
  const { axiosAuthInstance, axiosInstance } = useAxiosInstances();

  const activateTwoFactor = async (data: IActivateTwoFactorRequest): Promise<IActivateTwoFactorResponse> => {
    try {

      const response = await axiosAuthInstance.post('/routes/authentication/two-factor/activate', data);
      return response.data.result;
    } catch (error: any) {
      // ✅ TRATAMENTO DE ERRO CORRETO
      if (error?.response?.data?.result) {
        throw {
          message: error.response.data.result.message,
          type: error.response.data.result.type
        }
      } else {
        throw {
          message: 'Erro desconhecido',
          type: 'unknown'
        }
      }
    }
  };

  const verifyTwoFactor = async (data: IVerifyTwoFactorRequest): Promise<IVerifyTwoFactorResponse> => {
    try {
      // ✅ PEGAR token manualmente:
      const token = localStorage.getItem('ACCESS_TOKEN');
      
      // ✅ ADICIONAR header manualmente:
      const config = {
        headers: {
          'Authorization': `bearer ${token}`
        }
      };
      
      const response = await axiosAuthInstance.post('/routes/authentication/two-factor/verify', data, config);
      return response.data.result;
    } catch (error: any) {
      // ✅ TRATAMENTO DE ERRO:
      if (error?.response?.data?.result) {
        throw {
          message: error.response.data.result.message,
          type: error.response.data.result.type
        }
      } else {
        throw {
          message: 'Erro desconhecido',
          type: 'unknown'
        }
      }
    }
  };

  const completeTwoFactorLogin = async (data: ICompleteTwoFactorLoginRequest): Promise<ICompleteTwoFactorLoginResponse> => {
    try {
      const response = await axiosInstance.post('/routes/authentication/two-factor/complete-login', {
        code: data.code,           // ✅ PRIMEIRO: code
        tempToken: data.tempToken, // ✅ SEGUNDO: tempToken
        useBackupCode: data.useBackupCode
      });
      return response.data.result;
    } catch (error: any) {
      // ✅ TRATAMENTO DE ERRO:
      if (error?.response?.data?.result) {
        throw {
          message: error.response.data.result.message,
          type: error.response.data.result.type
        }
      } else {
        throw {
          message: 'Erro desconhecido',
          type: 'unknown'
        }
      }
    }
  };

  const deactivateTwoFactor = async (data: IDeactivateTwoFactorRequest): Promise<IDeactivateTwoFactorResponse> => {
    const response = await axiosAuthInstance.post('/routes/authentication/two-factor/deactivate', data);
    return response.data.result;
  };

  const generateBackupCodes = async (data: IGenerateBackupCodesRequest): Promise<IGenerateBackupCodesResponse> => {
    const response = await axiosAuthInstance.post('/routes/authentication/two-factor/backup-codes', data);
    return response.data.result;
  };

  const configureCompanyTwoFactor = async (data: IConfigureCompanyTwoFactorRequest): Promise<IConfigureCompanyTwoFactorResponse> => {
    const response = await axiosAuthInstance.post('/routes/authentication/two-factor/organization-config', data);
    return response.data.result;
  };

  return {
    activateTwoFactor,
    verifyTwoFactor,
    completeTwoFactorLogin,
    deactivateTwoFactor,
    generateBackupCodes,
    configureCompanyTwoFactor
  };
};